import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Send, MessageCircle, MapPin, User } from "lucide-react";
import api, { resolveImg } from "@/lib/api";
import { useSettings } from "@/lib/settings";
import RequestForm from "@/components/RequestForm";

export default function ContactsPage() {
    const settings = useSettings();

    return (
        <>
        <title>Контакты | AutoTreider</title>
        <meta name="description" content={`Свяжитесь с ${settings?.company_name || "AutoTreider"} для подбора и заказа автомобиля из Европы.`} />
        <link rel="canonical" href="https://autotreider.eu/contacts" />
        <meta property="og:title" content={`${settings?.contacts_subtitle || "Контакты"} | ${settings?.company_name || "AutoTreider"}`} />
        <meta property="og:description" content={`Свяжитесь с ${settings?.company_name || "AutoTreider"} для подбора автомобиля из Европы.`} />
        <meta property="og:url" content="https://autotreider.eu/contacts" />
        <div className="min-h-screen pt-16 sm:pt-20" data-testid="contacts-page">
            <section className="relative h-[25vh] sm:h-[40vh] flex items-center" style={{ background: "linear-gradient(to bottom, #09090b, #020202)" }}>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
                    <p className="text-[#0099FF] text-xs uppercase tracking-[0.3em] mb-2 sm:mb-3 font-body">{settings?.contacts_subtitle || "Контакты"}</p>
                    <h1 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white font-display">{settings?.contacts_title || "Свяжитесь с нами"}</h1>
                    {settings?.address && <div className="flex items-center gap-2 text-zinc-400 mt-3 sm:mt-4 text-sm font-body"><MapPin className="w-4 h-4 flex-shrink-0" />{settings.address}</div>}
                </div>
            </section>
            <section className="py-12 sm:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16">
                    <div>
                        <h2 className="text-lg sm:text-xl font-bold text-white mb-6 sm:mb-8 font-display">{settings?.contacts_managers_title || "Наши менеджеры"}</h2>
                        <div className="space-y-4 sm:space-y-6">
                            {settings?.managers?.map((m, i) => (
                                <motion.div key={i} initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-[#09090b] border border-white/5 p-4 sm:p-6 flex items-center gap-4 sm:gap-6" data-testid={`manager-card-${i}`}>
                                    {m.photo ? <img src={resolveImg(m.photo)} alt={m.name} className="w-12 h-12 sm:w-16 sm:h-16 object-cover flex-shrink-0" /> : <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/5 flex items-center justify-center flex-shrink-0"><User className="w-6 h-6 sm:w-8 sm:h-8 text-zinc-600" /></div>}
                                    <div className="flex-1 min-w-0">
                                        <h3 className="text-white font-semibold text-base sm:text-lg font-body">{m.name}</h3>
                                        <div className="flex flex-wrap gap-2 sm:gap-3 mt-2 sm:mt-3">
                                            {m.telegram && <a href={m.telegram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-[#0099FF] text-sm hover:text-white transition-colors font-body" data-testid={`manager-telegram-${i}`}><Send className="w-4 h-4" /> Telegram</a>}
                                            {m.whatsapp && <a href={m.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-emerald-400 text-sm hover:text-white transition-colors font-body" data-testid={`manager-whatsapp-${i}`}><MessageCircle className="w-4 h-4" /> WhatsApp</a>}
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h2 className="text-xl font-bold text-white mb-8 font-display">{settings?.contacts_form_title || "Напишите нам"}</h2>
                        <div className="bg-[#09090b] border border-white/5 p-8">
                            <RequestForm source="contact" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        </>
    );
}
